export default {
  functional: true,
  props: {
    url: {
      type: [String, Object, Boolean]
    }
  },
  render (h, ctx) {
    let url = ctx.props.url
    if (!url) {
      return h('div', {}, ctx.children)
    }
    url = url.replace(window.location.origin, '')
    url = url.replace(process.env.VUE_APP_API_URL, '')

    // external links
    if (url.includes('http')) {
      return h('a', {
        attrs: {
          href: url,
          target: '_blank',
          rel: 'noopener'
        }
      }, ctx.children)
    }
    return h('router-link', {
      props: { to: url }
    }, ctx.children)
  }
}
